import { diffOrderedLists } from './diffOrderedLists';

export interface StringDiffEqual {
    op: '=';
    value: string;
}

export interface StringDiffInsert {
    op: '+';
    value: string;
}

export interface StringDiffDelete {
    op: '-';
    value: string;
}

export type StringDiff = StringDiffEqual | StringDiffInsert | StringDiffDelete;

/**
 * Diff two strings.
 */
export function diffStrings(before: string, after: string): StringDiff[] {
    return diffOrderedLists(before.split(''), after.split(''), (a, b) => a === b).map((diff) => {
        switch (diff.op) {
            case '=':
                return { op: '=', value: diff.values.join('') };
            case '+':
                return { op: '+', value: diff.values.join('') };
            case '-':
                return { op: '-', value: diff.values.join('') };
        }
    });
}
